module.exports = __webpack_public_path__ + "images/icon-menu_96027c829ad5372071dfaf0f1a1790b8.png";